module.exports = __webpack_public_path__ + "static/media/km.05c0e1c1.svg";